<template>
  <div class="product-item">
    <div class="product-inner">
      <div class="product-image">
        <div class="loader-wrapper">
          <div class="loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
      </div>
      <div class="product-name text-truncate">
        {{ loadingText }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      loadingText: "Fetching...",
      start: null,
      time: 0,
      elapsed: "0.0"
    };
  },

  props: {
    layerProduct: {
      type: Object,
      required: true
    }
  },

  mounted() {
    this.start = new Date().getTime();
    setTimeout(() => this.timer(), 100);
    this.generateLoadingText;
  },

  computed: {
    ...mapGetters({
      builderOutfit: "builderOutfit"
    }),

    generateLoadingText() {
      let that = this;

      setTimeout(function() {
        that.loadingText = "Processing data...";

        setTimeout(function() {
          that.loadingText = "Saving...";
        }, that.randomTime);
      }, that.randomTime);
    },

    randomTime() {
      const min = 3000;
      const max = 5500;

      return Math.round(Math.random() * (max - min + 1)) + min;
    }
  },

  methods: {
    timer() {
      this.time += 100;

      this.elapsed = Math.floor(this.time / 100) / 10;
      if (Math.round(this.elapsed) == this.elapsed) {
        this.elapsed += ".0";
      }

      var diff = new Date().getTime() - this.start - this.time;
      setTimeout(() => this.timer(), 100 - diff);
    }
  },

  watch: {
    time: function(newVal, oldVal) {
      if (newVal > 40000) {
        this.loadingText = "Won't be long now...";
      } else if (newVal > 34000) {
        this.loadingText = "Taking longer than usual...";
      } else if (newVal > 25000) {
        this.loadingText = "Bare with us...";
      } else if (newVal > 20000) {
        this.loadingText = "Still working...";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.product-item {
  flex-basis: calc((100% / 3) - 1rem);
  margin: 0 0 1rem 1rem;
  margin-top: 35px;

  .product-inner {
    background: white;
    border: 1px dashed $grey5;
    border-radius: 0.3em !important;
    padding: 5px;
  }

  @include for-tablet-portrait-up {
    flex-basis: calc((100% / 4) - 1rem);

    .product-inner {
      padding: 8px;
    }
  }

  @include for-tablet-landscape-up {
    flex-basis: calc((100% / 5) - 1rem);

    .product-inner {
      padding: 10px;
    }
  }

  @include for-desktop-up {
    flex-basis: calc((100% / 5) - 1rem);
  }

  .product-image {
    position: relative;
    background-color: white;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    min-height: 100px;

    @include for-tablet-portrait-up {
      min-height: 175px;
    }

    @include for-tablet-landscape-up {
      min-height: 175px;
    }

    @include for-desktop-up {
      min-height: 220px;
    }
  }

  .product-name {
    color: $grey3;
    padding-top: 5px;
    text-align: center;

    @include for-tablet-portrait-up {
      padding-top: 8px;
    }

    @include for-tablet-landscape-up {
      padding-top: 10px;
    }
  }

  .product-actions {
    margin-top: 20px;
    margin-bottom: 30px;
    text-align: center;
  }
}

.loader-wrapper {
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  color: #979c9c;
  vertical-align: middle;
  text-decoration: none;
  z-index: 1;
  border: none;
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 5%;
  transform: translate3d(-50%, -50%, 0);
  text-align: center;
}

.dot {
  width: 14px;
  height: 14px;
  background: #3ac;
  border-radius: 100%;
  display: table-cell;
  animation: slide 1s infinite;

  &:nth-child(1) {
    animation-delay: 0.1s;
    background: $primary-accent;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
    background: #64aacc;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
    background: #96aacc;
  }

  &:nth-child(4) {
    animation-delay: 0.4s;
    background: #c8aacc;
  }

  &:nth-child(5) {
    animation-delay: 0.5s;
    background: #faaacc;
  }
}

@keyframes slide {
  0% {
    transform: scale(1);
  }

  50% {
    opacity: 0.3;
    transform: scale(2);
  }

  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/layerGroup/LayerProductEmpty.vue